import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import useDriverProfile from '@/useDriverProfile';

import WorkingLogsDisplay from '@/components/Driver/WorkingLogsDisplay.vue';
import AvailableVehicleDisplay from '@/components/Driver/AvailableVehicleDisplay.vue';

const { mapLastSevenDaysDeliveryNotes } = useDriverProfile();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    name: {
      name: 'ชื่อ',
      width: '10rem',
    },
    employeeCode: {
      name: 'รหัสพนักงาน',
      width: '6rem',
    },
    citizenId: {
      name: 'เลขประจำตัวประชาชน',
      width: '10rem',
    },
    primaryTelephone: {
      name: 'เบอร์โทรศัพท์',
      width: '6rem',
    },
    secondaryTelephone: {
      name: 'เบอร์โทรศัพท์รอง',
      width: '8rem',
    },
    workLoad: {
      name: 'ประวัติ',
      width: '4rem',
      component: defineComponent({
        render(createElement: any) {
          return createElement(
            WorkingLogsDisplay,
            {
              attrs: {
                distanceArray: mapLastSevenDaysDeliveryNotes((this as any).row.item.paginatedDeliveryNotes.data),
              },
              props: { row: {} },
            },
          );
        },
        props: { row: {} },
      }),
    },
    // dateOfBirth: {
    //   name: 'วันเกิด',
    //   width: '6rem',
    //   filter: (val: string) => {
    //     if (val === null || val === '') return '';
    //     return useFormat.date(val).displayShortThaiDate();
    //   },
    // },
    address: {
      name: 'ที่อยู่',
      width: '2rem',
    },
    avatarUrl: {
      name: '',
      width: '3rem',
    },
    availableVehicleType: {
      name: 'รถที่สามารถขับได้',
      width: '17.8rem',
      component: defineComponent({
        render(createElement: any) {
          return createElement(
            AvailableVehicleDisplay,
            {
              attrs: {
                vehicle: (this as any).row.item.availableVehicleType,
              },
              props: { row: {} },
            },
          );
        },
        props: { row: {} },
      }),
      filter: () => '',
    },
    active: {
      name: '',
      width: '2rem',
    },
    createdAt: {
      name: '',
      width: '2rem',
    },
    updatedAt: {
      name: '',
      width: '2rem',
    },
  },
  search: {
    for: 'รหัสพนักงาน / ชื่อพนักงาน',
    column: 'Name',
  },
  columns: [
    '_increment',
    'employeeCode',
    'avatarUrl',
    'name',
    'availableVehicleType',
    'workLoad',
    // 'dateOfBirth',
    // 'citizenId',
    'primaryTelephone',
    'secondaryTelephone',
    // 'address',
  ],
  grids: [
    'avatarUrl',
    'name',
    'workLoad',
    'employeeCode',
    // 'citizenId',
    // 'dateOfBirth',
    'availableVehicleType',
  ],
};
